import { render, staticRenderFns } from "./stu_qulity.vue?vue&type=template&id=97a19f0c&scoped=true"
import script from "./stu_qulity.vue?vue&type=script&lang=js"
export * from "./stu_qulity.vue?vue&type=script&lang=js"
import style0 from "./stu_qulity.vue?vue&type=style&index=0&id=97a19f0c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a19f0c",
  null
  
)

export default component.exports